/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { smartphoneWirelessDuocolor } from "../assets/smartphone-wireless-duocolor";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconSmartphoneWirelessDuocolor = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={smartphoneWirelessDuocolor.svg} />
);

IllustrativeIconSmartphoneWirelessDuocolor.displayName = "IllustrativeIconSmartphoneWirelessDuocolor";
